import { setup, assign, fromCallback } from "xstate"

interface GuideMachineContext {
  frames: number
  page: number
  progress: number
}

interface CreateGuideMachineParam {
  fps?: number
  trigger: { [k: number]: number }
  end: number
}

export const createGuideMachine = ({ fps = 10, trigger, end }: CreateGuideMachineParam) => {
  return setup({
    types: {
      context: {} as GuideMachineContext,
      events: {} as { type: "TICK" } | { type: "RESET" },
    },
    actions: {
      tickAction: assign(({ context }) => {
        const newFrames = context.frames + 1
        const newPage = trigger[newFrames]
        return { frames: newFrames, page: newPage || context.page, progress: newFrames / end }
      }),
      resetAction: assign({ frames: 0, page: 0, progress: 0 }),
    },
    guards: {
      isComplete: ({ context }) => context.frames >= end,
      isNotComplete: ({ context }) => context.frames < end,
    },
    actors: {
      ticker: fromCallback(({ sendBack }) => {
        const interval = setInterval(() => {
          sendBack({ type: "TICK" })
        }, 1000 / fps)
        return () => {
          clearInterval(interval)
        }
      }),
    },
  }).createMachine({
    id: "guide",
    initial: "running",
    context: {
      frames: 0,
      page: 0,
      progress: 0,
    },
    states: {
      running: {
        invoke: {
          src: "ticker",
        },
        always: [
          {
            target: "paused",
            guard: "isComplete",
          },
        ],
        on: {
          TICK: {
            actions: "tickAction",
          },
        },
      },
      paused: {
        always: [
          {
            target: "running",
            guard: "isNotComplete",
          },
        ],
      },
    },
    on: {
      RESET: {
        actions: "resetAction",
      },
    },
  })
}
